/**
 * Map legend/callout swatch palette
 *
 * DS-internal resolver mapping a SEMANTIC level to a muem9.18 map-swatch token.
 * Pages and sealed descriptors express legend bins by semantic `level` only; a
 * raw colour or colour ramp can never cross the public boundary. Swatch colours
 * live here (token-backed) so the whole hazard/economics/status palette is
 * centrally restyleable.
 */

/** Semantic legend/callout level. Names are meaning, not colour. */
export type FmMapLegendLevel =
  | 'low'
  | 'moderate'
  | 'critical'
  | 'positive'
  | 'negative'
  | 'neutral'
  | 'info';

const LEVEL_SWATCH_TOKEN: Record<FmMapLegendLevel, string> = {
  low: 'var(--fm-map-swatch-low)',
  moderate: 'var(--fm-map-swatch-moderate)',
  critical: 'var(--fm-map-swatch-critical)',
  positive: 'var(--fm-map-swatch-positive)',
  negative: 'var(--fm-map-swatch-negative)',
  neutral: 'var(--fm-map-swatch-neutral)',
  info: 'var(--fm-map-swatch-info)',
};

/** Resolve a semantic level to its token-backed swatch colour (var(...) form). */
export function resolveLegendSwatch(level: FmMapLegendLevel): string {
  return LEVEL_SWATCH_TOKEN[level];
}
